import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';

// https://medium.com/wizdm-genesys/angular-redirecting-to-external-links-bd3e785325c6
@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  constructor(@Inject(DOCUMENT) readonly document: Document) {
  }

  get window(): Window {
    return this.document.defaultView;
  }

  public jump(url: string, target: string = '_blank'): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      try {
        resolve(!!this.window.open(url, target));
      } catch (e) {
        reject(e);
      }
    });
  }
}
